import React, { Component } from 'react';

import {
    WithStyles, createStyles, Button, Typography, Grid
} from '@material-ui/core';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import { MyPATFileUpload, MyPATTextField } from '../../../../common';
import { videoActions } from '../../../reducers/videoCreateContentReducers';
import { VIDEO_UPLOAD_MODES } from '../../../../../constants/comman';

const styles = (theme: Theme) => createStyles({
    OrDivider: {
        margin: "25px 0",
        display: "block",
        position: "relative",
        textAlign: "center",
        height: "50px",
        zIndex: 0,
    },
    orText: {
        background: "#E0E6E7",
        height: "40px",
        width: "40px",
        borderRadius: "100%",
        fontStyle: "italic",
        fontSize: 14,
        color: "#989898",
        display: "inline-block",
        paddingTop: "8px",
        "position": "absolute",
        "top": "-20px",
        left : "50%",
        marginLeft : "-25px",
    },
    dividerBar: {
        "position": "absolute",
        "left": 0,
        "top": "15px",
        width: "100%",
        "content": " ",
        height: "1px",
        background: "#E0E6E7",
        "z-index": "1",
    },
    button: {
        margin: theme.spacing.unit,
    },
    addQuestionTitle:{
        fontSize: 16,
        fontWeight: 400, 
        fontFamily: 'Nunito',
    },
    addVideoBrowse:{
        width:'850px',
        margin:'0 auto',
    },
});

interface VideoUploadDialogProps extends WithStyles<typeof styles> {
    classes: any;
    onDialogClose: Function;
    videoUrl: string;
    handleURL: Function;
    openVideoUrlModal: Function;
    videoDetails: any;
    uploadVideo: Function;
    mode: string;
}

interface VideoUploadDialogState {
}

class VideoUploadDialog extends Component<VideoUploadDialogProps, VideoUploadDialogState> {
    checkUrlValidity = (videoUrl:any) => {
        if (
            videoUrl.length && (
                videoUrl.startsWith('https://youtu.be/')
                || videoUrl.startsWith('https://www.youtube.com/')
            )
        ) return true;
        return false;
    }

    handleVideoUrl = (e: any) => {
        e.preventDefault();
        this.props.handleURL(e.target.value);
        
    }

    handleSubmitUrl = () => {
        const { openVideoUrlModal } = this.props;
        openVideoUrlModal();
    }

    render() {
        const {
            classes,
            onDialogClose,
            videoUrl,
            uploadVideo,
            mode
        } = this.props;

        return (
            <>
                <MyPATFileUpload videoUploadHandler={uploadVideo}/>
                <Typography variant="caption" className={classes.OrDivider}>
                    <span className={classes.dividerBar}><b className={classes.orText}> OR </b></span>
                </Typography>
                <Grid item xs={12} className={classes.addVideoBrowse}>
                    <Grid container alignItems="center" justify="center" spacing={8} >
                        <Grid item xs={1}>
                        <b className={classes.addQuestionTitle}>URL:</b>
                        </Grid>
                        <Grid item xs={6}>
                            <MyPATTextField
                                inputId="videoUrl"
                                name="videoUrl"
                                fullWidthControl
                                placeholder="Enter URL here"
                                value={videoUrl}
                                inputProps={{
                                    required: true,
                                    onChange: (e: any) => this.handleVideoUrl(e)
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item sm ></Grid>
                    {mode=== VIDEO_UPLOAD_MODES.EDIT? '' : <Grid item>
                        <Button
                            className={classes.button}
                            color="primary"
                            onClick={() => onDialogClose()}
                        >
                            Cancel
						</Button>
                    </Grid>
                   }
                    <Grid item>
                        <Button
                            disabled={!this.checkUrlValidity(videoUrl)}
                            className={classes.button}
                            variant="contained"
                            color="primary"
                            onClick={this.handleSubmitUrl}
                        >
                            Ok
						</Button>
                    </Grid>
                </Grid>
            </>
        )


    }
}

const mapStateToProps = (state: any) => {
    return {
        videoUrl: state.videoCreateContent.videoURL,
        videoDetails: state.videoCreateContent.videoDetails,
    }
};

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
    handleURL: videoActions.videoUrlChanged,
    openVideoUrlModal: videoActions.openVideoUrlModal,
}, dispatch);
// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(VideoUploadDialog));